"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const TourContext_1 = require("context/TourContext");
const TourComponent_1 = __importDefault(require("./TourComponent"));
const TourPortal = () => {
    const { tourStart, currentStepData } = (0, TourContext_1.useTourContext)();
    if (!tourStart || currentStepData == null)
        return react_1.default.createElement(react_1.default.Fragment, null);
    const targetElement = document.getElementById('shared-onboard');
    if (!targetElement)
        return react_1.default.createElement(react_1.default.Fragment, null);
    const { targetQuerySelector, forcedCloseQuerySelector, timeout, wait, scrollToElement } = currentStepData;
    return react_dom_1.default.createPortal(react_1.default.createElement(TourComponent_1.default, { targetQuerySelector: targetQuerySelector, forcedCloseQuerySelector: forcedCloseQuerySelector, timeout: timeout, waitElement: wait, scrollToElement: scrollToElement }), targetElement);
};
exports.default = TourPortal;
